// extracted by mini-css-extract-plugin
export default {"TableCol":"SortedTable_TableCol__lkpCO"};